import {Component, Input} from '@angular/core';

@Component({
    selector: 'scitis-toggle-arrow',
    templateUrl: './toggle-arrow.component.html',
    standalone: false
})
export class ToggleArrowComponent {

  @Input() isInvisible: boolean = false;
  @Input() isOpen: boolean = false;
}
